module.exports = __webpack_public_path__ + "img/card-bg-desktop.4c3536f.webp";